import { Spacer } from "./styles";

const AdjustableSpacer = (props) => {
  return <Spacer width={props.width} height={props.height} mobileHeight = {props.mobileHeight}/>;
};
export default AdjustableSpacer;
